import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { contentApi, CATEGORY_LABEL } from "@/data/api";

export default function AdminContentList() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentApi.adminList(token).then((r) => setItems(r.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, [token]);

  return (
    <Screen>
      <TopBar title="Content Vault" subtitle="Manage posts, captions & ideas" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <button data-testid="new-content-button" className="pressable" onClick={() => navigate("/admin/content-edit")} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: colors.brand, color: colors.onBrand, border: "none", borderRadius: 12, padding: "13px", marginBottom: 18, cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: fonts.text }}>
          <Icon name="plus" size={16} color={colors.onBrand} />New content item
        </button>
        {loading ? <Loader /> : items.length === 0 ? (
          <div style={{ padding: 40, textAlign: "center", color: colors.muted, fontFamily: fonts.text }}>No content yet. Add your first item ✨</div>
        ) : items.map((it) => (
          <button key={it.id} data-testid={`content-row-${it.id}`} className="pressable" onClick={() => navigate(`/admin/content-edit?id=${it.id}`)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: 14, marginBottom: 10, cursor: "pointer", textAlign: "left" }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ color: colors.onSurface, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>{it.title}</span>
                {it.featured ? <Icon name="star" size={14} color={colors.brandSecondary} /> : null}
                {it.archived ? <span style={{ color: colors.muted, fontSize: 11, fontFamily: fonts.text }}>(archived)</span> : null}
              </div>
              <div style={{ color: colors.muted, fontSize: 12, marginTop: 2, fontFamily: fonts.text }}>{CATEGORY_LABEL[it.category] || it.category}</div>
            </div>
            <Icon name="chevron-right" size={20} color={colors.muted} />
          </button>
        ))}
      </div>
    </Screen>
  );
}
